import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, { ReactNode, ReactNodeArray } from 'react';
import UnsubscribeMail from './UnsubscribeMail';
import UnsubscribeMailBlockData from '../../../Models/Content/UnsubscribeMailBlockData';

export default class UnsubscribeMailBlock extends EpiComponent<UnsubscribeMailBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <UnsubscribeMail context={this.getContext()} iContent={this.props.data} />;
  }
}